<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'PALABRACLAVE.LBL_PALABRACLAVE' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fPalabraClave" name="nomPalabraClave">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'PALABRACLAVE.LBL_CODIGO' | translate }}</label>
                <div *ngIf="!palClave">
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="20"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'PALABRACLAVE.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
                <div *ngIf="palClave && palClave.idPalabraClave">
                  <label class="falso-combo-texto">{{palClave.codigo}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'PALABRACLAVE.LBL_NOMBRE' | translate }}</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="nombre"
                       [maxlength]="100"
                       capitalize-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                  {{ 'PALABRACLAVE.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 md:col-12 lg:col-12">
              <p-pickList  [source]="lisActividadesDisponibles" filterBy="actividadEconomica"
                          [showSourceControls]="false"
                          [showTargetControls]="false"
                          (onMoveToTarget)="cambioItems()"
                          (onMoveToSource)="cambioItems()"
                          (onMoveAllToTarget)="cambioItems()"
                          (onMoveAllToSource)="cambioItems()"
                          [target]="lisActividadesSeleccionadas" sourceHeader="{{ 'PALABRACLAVE.LBL_ACTIVIDADDISPONIBLE' | translate}}"
                          targetHeader="{{ 'PALABRACLAVE.LBL_ACTIVIDADSELECCIONADA' | translate}}">
                <ng-template let-actividad pTemplate="item">
                  {{actividad.actividadEconomica}}
                </ng-template>
                <ng-template let-actividad pTemplate="emptymessagesource">
                  {{ 'LBL_SINRESULTADOS' | translate}}
                </ng-template>
                <ng-template let-actividad pTemplate="emptymessagetarget">
                  {{ 'LBL_SINRESULTADOS' | translate}}
                </ng-template>
              </p-pickList>
            </div>
          </div>


          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                          id="indicador"
                          name="nomIndicador"
                          formControlName="indicadorHabilitado"></p-checkbox>
            </div>
          </div>

          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
